import React from "react";

var today = new Date();
var year = today.getFullYear();

const Footer = () => {
  return (
    <div className="mt-12 pb-12 text-center">
      <div className="h-1 w-16 bg-dividers mb-4 mx-auto"></div>
      <p className="font-light text-xs">Copyright {year}</p>
    </div>
  );
};

export default Footer;
